import {
  I2cInput,
  I2cListItem, I2cRadioGroup, I2cRadio, I2cAlert, I2cCheckbox, I2cCheckboxGroup,
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect, useState, useRef } from "react";
import style from "../csd.module.scss";
import "../../PrepaidComponents/Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { authMethods, additionalAuthData, additionalAuthDataPrepaid } from "./stringUtils";
import { CheckboxRenderer, InputRenderer } from "./CellRenderer";
import { validationSchemaAdditionalAuth } from "./ValidationSchema";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
import { I2cDataTable } from '@webcomponents/i2cwebcomponents/dist/react';

const AdditionalAuthentications = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,                  
}) => {
  const table = useRef();
  const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];
  const [rowDataInitial, setRowDataInitial] =  useState([]
  );
  const [gridOptions, setGridOptions] = useState({});
  const [isFormDataUpdated, setIsFormDataUpdated] = useState(false);

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchemaAdditionalAuth),
    mode: 'onChange',
    reValidateMode: 'onChange',
    // reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    // criteriaMode: "all",
    criteriaMode: "firstError",
    defaultValues: {
      additional_auth_methods: "",
      additional_auth_methods_other: "",
      additional_auth_otp_channels: "",
      additional_auth_methods_secondary: "",
      additional_auth_methods_secondary_other: "",
      additional_auth_feature_additional_auth: []
    },
  });

  const fields = [
    "additional_auth_methods",
    "additional_auth_methods_other",
    "additional_auth_otp_channels",
    "additional_auth_methods_secondary",
    "additional_auth_methods_secondary_other",
    "additional_auth_feature_additional_auth"
  ];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      if (type === "credit") {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[4]["4_0"][field] ?? "");
        });
      }
      else {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[5]["5_0"][field] ?? "");
        });
      }
      methods.trigger();
      setIsFormDataUpdated(true); // Signal that form data has been updated
    }
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;
 
  useEffect(() => {
    if (isFetching) return; 
    const backendData =
      type === "credit"
        ? formDataJson?.[4]?.["4_0"]?.additional_auth_feature_additional_auth
        : formDataJson?.[5]?.["5_0"]?.additional_auth_feature_additional_auth;

    const rowData = Array.isArray(backendData) && backendData.length > 0
      ? backendData
      : type === "credit"
        ? additionalAuthData
        : additionalAuthDataPrepaid;

    console.log("rowData:", rowData); // Debug: Check rowData

    // Update form state only if different
    const currentRowData = methods.getValues("additional_auth_feature_additional_auth");
    if (JSON.stringify(currentRowData) !== JSON.stringify(rowData)) {
      methods.setValue("additional_auth_feature_additional_auth", rowData, { shouldValidate: true });
      console.log("Form state:", methods.getValues("additional_auth_feature_additional_auth")); // Debug: Check form state
    }

    const newGridOptions = {
      columnDefs: [
        { headerName: "Feature", field: "feature", cellRenderer: CheckboxRenderer },
        { headerName: "Custom Menu Name", field: "alternativeMethod", cellRenderer: InputRenderer },
      ],
      rowSelection: "single",
      rowData,
      suppressMoveWhenRowDragging: true,
      context: { methods, handleValueChanges },
    };

    setGridOptions(newGridOptions);

    const api = table?.current?.getGridApi();
    if (api && api.setRowData && !api.isDestroyed()) { 
      api.setRowData(rowData); 
    }
  }, [formDataJson, isFetching, methods]);

  React.useEffect(() => {
    methods.trigger();
  }, []);
  const handleValueChanges = () => {
    const updatedValues = methods.getValues();

    if (type === "credit") {
      setAddFormData((prevData) => ({

        ...prevData,
        4: {
          ...prevData["4"],
          "4_0": {
            ...prevData["4"]["4_0"],
            ...updatedValues, // Merging updated values
          },
        },
      }));
    } else {
      setAddFormData((prevData) => ({
        ...prevData,
        5: {
          ...prevData["5"],
          "5_0": {
            ...prevData["5"]["5_0"],
            ...updatedValues, // Merging updated values
          },
        },
      }));
    }
  };
  console.log("error in additional authentications", errors);
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (type === "credit") {
      if (errorsLength === 0) setFormValidStates("4_0", true);
      else setFormValidStates("4_0", false);
    }
    else {
      if (errorsLength === 0) setFormValidStates("5_0", true);
      else setFormValidStates("5_0", false);
    }
    handleValueChanges();
  }, [Object.keys(errors).length]);

  const selectedPrimaryMethod = methods.watch("additional_auth_methods");
  const selectedFallbackMethod = methods.watch("additional_auth_methods_secondary");
  const alertProfileInfoVerification = (
    <I2cAlert
      open
      type="plain"
      variant="neutral"
      headerArt="cs-linear-info"
      layout="layoutAsideLeft"
      closable
    >
      <span slot="label">The profile information verification method supports the verification of the following fields.</span>
      <ul>
        <li>Access code</li>
        <li>Expiry </li>
        <li>Date of birth</li>
        <li>PIN</li>
        <li>Last 4 SSN [for US only]</li>
        <li>Last 4 Home Number</li>
      </ul>
    </I2cAlert>
  )

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="10@md">
            <div className="sub-heading mb-4">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Additional Authentication
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
            <div className="custom-label">
              This section lists various card activation and registration options for a consumer who already has received a card and would like to create an account, to use the application.
            </div>
          </div>
          <div i2c-grid="12">
            <div className="custom-label mb-8">
              Please select the additional authentication methods you want to support. Choose an item.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="additional_auth_methods"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cRadioGroup
                      onI2cChange={(e) => {
                        methods.setValue("additional_auth_methods", e.target.value);
                        if(e.target.value !== "Other Methods"){
                          methods.setValue("additional_auth_methods_other","")
                        }
                        else if(e.target.value !== "One Time Password (OTP)"){
                          methods.setValue("additional_auth_otp_channels","")
                        }
                        else if(e.target.value === "Other Methods"){
                          methods.setValue("additional_auth_methods_secondary_other","")
                        }
                        methods.trigger();
                        handleValueChanges();
                      }}
                    >
                      <div i2c-grid="grid gap-sm">
                        {authMethods.map((cpi, index) => (
                          <I2cListItem
                            key={cpi.value + index}
                            i2c-grid="4@md"
                            variant="receipt"
                            label={cpi.label}
                            sublabel=""
                            value=""
                            disabled={cpi.value === selectedFallbackMethod && selectedFallbackMethod != "Other Methods"}
                            checked={methods.watch("additional_auth_methods") === cpi.value}
                            type="checkbox"
                          >
                            <I2cRadio
                              slot="prefix"
                              name="credit_programType"
                              value={cpi.value}
                              filled
                              label=""
                              disabled={cpi.value === selectedFallbackMethod && selectedFallbackMethod != "Other Methods"}
                              checked={
                                methods.watch("additional_auth_methods") === cpi.value
                              }
                            />
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cRadioGroup>
                  </>
                )}
              />
            </div>
          </div>
          {methods.watch("additional_auth_methods") === "One Time Password (OTP)" && (
            <div i2c-grid="12">
              <div className="custom-label mb-8">
                Select Otp Channels
              </div>
              <div className="single-field-wrapper">
                <Controller
                  name="additional_auth_otp_channels"
                  control={control}
                  render={({ field }) => (
                    <>
                      <I2cRadioGroup
                        onI2cChange={(e) => {
                          methods.setValue("additional_auth_otp_channels", e.target.value);
                          methods.trigger();
                          handleValueChanges();
                        }}
                      >
                        <div i2c-grid="grid gap-sm">
                          {["Email", "SMS", "Both"].map((cpi, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="4@md"
                              variant="receipt"
                              label={cpi}
                              sublabel=""
                              value=""

                              checked={methods.watch("additional_auth_otp_channels") === cpi}
                              type="checkbox"
                            >
                              <I2cRadio
                                slot="prefix"
                                name="credit_programType"
                                value={cpi}
                                filled
                                label=""
                                checked={
                                  methods.watch("additional_auth_otp_channels") === cpi
                                }
                              />
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cRadioGroup>
                      <ErrorMessage
                        show={
                          errors.additional_auth_otp_channels &&
                            methods.formState.touchedFields.additional_auth_otp_channels
                            ? true
                            : false
                        }
                        message={errors.additional_auth_otp_channels?.message ?? "Invalid input"}
                      />
                    </>
                  )}
                />
              </div>
            </div>
          )}
          {methods.watch("additional_auth_methods") === "Other Methods" && (
            <div i2c-grid="12">
              <div className="single-field-wrapper">
                <Controller
                  name="additional_auth_methods_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className={style.halfWidth + " single-input-field"}
                      required
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                        methods.trigger();
                      }}
                      size="large"
                      label="Provide details about other methods and channels"
                      name={"additional_auth_methods_other"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.additional_auth_methods_other &&
                      methods.formState.touchedFields.additional_auth_methods_other
                      ? true
                      : false
                  }
                  message={
                    errors.additional_auth_methods_other?.message ??
                    "Invalid input"
                  }
                />
              </div>
            </div>
          )}
          {methods.watch("additional_auth_methods") === "Profile Information Verification" && (
            <div i2c-grid="12">
              {alertProfileInfoVerification}
            </div>
          )}
          <div i2c-grid="12">
            <div className="custom-label mb-8">
              Select a fallback additional authentication method if the system cannot perform verification using the first one.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="additional_auth_methods_secondary"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    onI2cChange={(e) => {
                      methods.setValue("additional_auth_methods_secondary", e.target.value);
                      if(e.target.value !== "Other Methods"  || selectedPrimaryMethod === "Other Methods"){
                        methods.setValue("additional_auth_methods_secondary_other","")
                      }
                      else if(e.target.value !== "One Time Password (OTP)"){
                        methods.setValue("additional_auth_otp_channels","")
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {authMethods.map((cpi, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          label={cpi.label}
                          sublabel=""
                          value=""
                          disabled={cpi.value === selectedPrimaryMethod && selectedPrimaryMethod != "Other Methods"}
                          checked={methods.watch("additional_auth_methods_secondary") === cpi.value}
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            name="credit_programType"
                            value={cpi.value}
                            filled
                            label=""
                            disabled={cpi.value === selectedPrimaryMethod}

                            checked={
                              methods.watch("additional_auth_methods_secondary") === cpi.value
                            }
                          />
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("additional_auth_methods_secondary") === "One Time Password (OTP)" && (
            <div i2c-grid="12">
              <div className="custom-label mb-8">
                Select Otp Channels
              </div>
              <div className="single-field-wrapper">
                <Controller
                  name="additional_auth_otp_channels"
                  control={control}
                  render={({ field }) => (
                    <I2cRadioGroup
                      onI2cChange={(e) => {
                        methods.setValue("additional_auth_otp_channels", e.target.value);
                        methods.trigger();
                        handleValueChanges();
                      }}
                    >
                      <div i2c-grid="grid gap-sm">
                        {["Email", "SMS", "Both"].map((cpi, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="4@md"
                            variant="receipt"
                            label={cpi}
                            sublabel=""
                            value=""
                            checked={methods.watch("additional_auth_otp_channels") === cpi}
                            type="checkbox"
                          >
                            <I2cRadio
                              slot="prefix"
                              name="credit_programType"
                              value={cpi}
                              filled
                              label=""
                              checked={
                                methods.watch("additional_auth_otp_channels") === cpi
                              }
                            />
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cRadioGroup>
                  )}
                />
              </div>
            </div>
          )}
          {methods.watch("additional_auth_methods_secondary") === "Other Methods" && (
            <div i2c-grid="12">
              <div className="single-field-wrapper">
                <Controller
                  name="additional_auth_methods_secondary_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className={style.halfWidth + " single-input-field"}
                      required
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                        methods.trigger();
                      }}
                      size="large"
                      label="Provide details about other methods and channels"
                      name={"additional_auth_methods_secondary_other"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.additional_auth_methods_other &&
                      methods.formState.touchedFields.additional_auth_methods_other
                      ? true
                      : false
                  }
                  message={
                    errors.additional_auth_methods_other?.message ??
                    "Invalid input"
                  }
                />
              </div>
            </div>
          )}
          {methods.watch("additional_auth_methods_secondary") === "Profile Information Verification" && (
            <div i2c-grid="12">
              {alertProfileInfoVerification}
            </div>
          )}
          <div i2c-grid="12">
            <div className="custom-label mb-8">
              Please select the features that you want to support additional authentication for. If you want to support a different set of additional
              authentication methods and channels, please provide details in the text field to override the general selection.
            </div>
            <Controller
              name="additional_auth_feature_additional_auth"
              control={control}
              render={({ field }) => (
                <I2cDataTable
                  id="dataTable1"
                  ref={table}
                  gridOptionInput={gridOptions}
                  notFound={[
                    {
                      description:
                        'No data available. Please add some features or refresh the page.',
                      type: 'noData',
                      icon: 'outline-info-circle',
                      primaryBtn: `<i2c-button variant="primary" size='large'>Reload</i2c-button>`,
                    },
                  ]}
                ></I2cDataTable>
              )}
            /> 
          </div> 
        </div>
      </div>
    </React.Fragment>
  );
};
export default AdditionalAuthentications;
